import React, {useEffect} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Row, Col, Icon } from "atomize";
import styled from "styled-components";
import {apiGet} from "../../../Api";
import {baseUrl} from "../../../Constants/constants";

const Wrapper = styled(Col)`
  margin-bottom: 1rem;
`;

const ItemDiv = styled(Div)`
  background-color: white;
  display: flex;
  border: 1px solid #F1F2F4;	
  border-radius: 8px;
  box-shadow: 0 0 1px 0 rgba(10,22,70,0.06), 0 1px 1px 0 rgba(10,22,70,0.1);
  cursor: pointer;
  height: 100%;
  align-items: center;
  
  transition: box-shadow .25s ease-in-out;
  
  svg path {
    transition: fill .25s ease-in-out;
  }
  
  &:hover, &:focus {
    box-shadow: 0 0 2px 0 rgba(10,22,70,0.06), 0 2px 2px 0 rgba(10,22,70,0.1);
    
    svg path {
      fill: ${theme.colors.secondary} !important;
    }
  }
`;

const Title = styled.h3`
  color: ${theme.colors.dark};	
  font-family: Inter;	font-size: 16px;	font-weight: 500;	line-height: 25px;
`;

const Authors = styled.p`
  color: ${theme.colors.grayDark};	
  //color: #8A94A6;
  font-family: Inter;
  font-size: 14px;
  line-height: 20px;
  margin-top: .5rem;
`;

const Publisher = styled.span`
  // color: ${theme.colors.gray};	
  color: #8A94A6;
  font-family: Inter;
  font-size: 12px;
  line-height: 20px;
  //text-transform: uppercase;
  margin-bottom: .5rem;
`;

const IconWrapper = styled.div`
  margin-right: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 30px;
    height: auto;
  }
  @media (max-width: 450px ) {
    margin-right: 1rem;
  }
`;

const renderIcon = (link, file) => {
  return (
    <IconWrapper>
      { link &&
        <Icon
          name={'Link'}
          color={theme.colors.primary}
        />
      }
      { !link &&
        <Icon
          name={'Download'}
          color={theme.colors.primary}
        />
      }
    </IconWrapper>
  )
};

function ResourceCard(props) {
  const resource = props.resource;
  const [data, setData] = React.useState({});

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`node/resource/${resource.id}?include=field_file&jsonapi_include=1`);
      setData(result.data.data);
    }

    fetchData();
  }, []);

  function handleClick() {
    if (resource.field_link) {
      window.open(resource.field_link.uri, "_blank");
    }
    if (!resource.field_link && data.field_file.uri) {
      window.open( baseUrl + data.field_file.uri.url, "_blank");
    }
  }

  return (
    <Wrapper
      size={{ xs: '12', sm: '12', md: '6', lg: '6' }}
    >
      <ItemDiv
        p={'1.5rem'}
        role={'link'}
        tabIndex={0}
        onClick={ () => handleClick() }
      >
        { renderIcon(resource.field_link, resource.field_file)}
        <Div>
          <Publisher>{ resource.field_publisher }</Publisher>
          <Title>{ resource.title }</Title>
          <Authors> { resource.field_authors } </Authors>
        </Div>
      </ItemDiv>
    </Wrapper>
  )
}

export default ResourceCard;
